import { ReportSdk } from 'lib-klab-sdks';
import { AdminActivitySummaryRequest } from '../../../domain/models/reports/request/admin-activity-summary.request';
import { AdminActivityDetailRequest } from '../../../domain/models/reports/request/admin-activity-detail.request';
import { AdminActivityExportRequest } from '../../../domain/models/reports/request/admin-export.request';
import { AdminActivitySummaryResponse } from '../../../domain/models/reports/admin-activity-summary-response.model';
import { AdminActivityDetailResponse } from '../../../domain/models/reports/admin-activity-detail-response.model';

export function toSdkAdminActivitySummaryRequest(
    payload: AdminActivitySummaryRequest,
): ReportSdk.AdminActivitySummaryRequest {
    return {
        type: payload.type as ReportSdk.ActivityTypeFilterEnum,
        dateRange: {
            startDate: payload.dateRange.startDate,
            endDate: payload.dateRange.endDate ?? payload.dateRange.startDate,
        },
        ...(payload.locationId != null ? { locationId: payload.locationId } : {}),
        ...(payload.departmentId != null ? { departmentId: payload.departmentId } : {}),
        ...(payload.search?.trim() ? { search: payload.search.trim() } : {}),
    };
}

export function toSdkAdminActivityDetailRequest(
    payload: AdminActivityDetailRequest,
): ReportSdk.AdminActivityDetailRequest {
    return {
        type: payload.type as ReportSdk.ActivityTypeFilterEnum,
        identifier: payload.identifier,
        dateRange: {
            startDate: payload.dateRange.startDate,
            endDate: payload.dateRange.endDate ?? payload.dateRange.startDate,
        },
        ...(payload.locationId != null ? { locationId: payload.locationId } : {}),
        ...(payload.departmentId != null ? { departmentId: payload.departmentId } : {}),
    };
}

export function toSdkAdminActivityExportRequest(
    payload: AdminActivityExportRequest,
): ReportSdk.AdminActivityExportRequest {
    return {
        type: payload.type as ReportSdk.ActivityTypeFilterEnum,
        dateRange: {
            startDate: payload.dateRange.startDate,
            endDate: payload.dateRange.endDate ?? payload.dateRange.startDate,
        },
        format: payload.format as ReportSdk.ExportFormatEnum,
        ...(payload.locationId != null ? { locationId: payload.locationId } : {}),
        ...(payload.departmentId != null ? { departmentId: payload.departmentId } : {}),
        ...(payload.search?.trim() ? { search: payload.search.trim() } : {}),
    };
}

export function mapSdkAdminActivitySummaryResponseToDomain(
    resp: ReportSdk.AdminActivitySummaryResponse,
): AdminActivitySummaryResponse {
    return {
        type: (resp?.type ?? 'WEB') as AdminActivitySummaryResponse['type'],
        content: (resp?.content ?? []).map((item) => ({
            identifier: item.identifier,
            totalSeconds: item.totalSeconds ?? 0,
            classification: item.classification ?? undefined,
        })),
    };
}

export function mapSdkAdminActivityDetailResponseToDomain(
    resp: ReportSdk.AdminActivityDetailResponse,
): AdminActivityDetailResponse {
    return {
        type: (resp?.type ?? 'WEB') as AdminActivityDetailResponse['type'],
        identifier: resp?.identifier ?? '',
        totalSeconds: resp?.totalSeconds ?? 0,
        employees: (resp?.employees ?? []).map((employee) => ({
            employeeId: employee.employeeId,
            code: employee.code ?? undefined,
            fullName: employee.fullName ?? undefined,
            totalSeconds: employee.totalSeconds ?? 0,
            classification: employee.classification ?? undefined,
        })),
    };
}
